<template>
  <div class="animated fadeIn">
    <basic-heading :title="date_for_title">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list schedule'">
      <template #gated-content>
        <DatePicker @date_change="(val) => selected_date = val" />
        <ScheduleIndicatorTiles />
        <div class="display-4 font-2xl my-3">Schedules</div>
        <schedule-server-table
          :filter_date="selected_date_obj"
          :filterable="[]"
          :show_buttons="false"
          ref="schedules-table"
          @updateTables="updateTables"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import moment from "moment";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import IndicatorBadge from "@/components/shared/IndicatorBadge";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import ScheduleServerTable from "@/components/lab/schedule/ScheduleServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import DatePicker from "@/components/shared/DatePicker.vue";
import ScheduleIndicatorTiles from "@/components/lab/schedule/ScheduleIndicatorTiles.vue"

export default {
  name: "ScheduleIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    IndicatorBadge,
    PermissionAlertGate,
    ScheduleServerTable,
    DatePicker,
    ScheduleIndicatorTiles,
  },
  data() {
    return {
      selected_date: null,
      date_format: "YYYY-MM-DD",
      approving: false,
      declining: false,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-calendar",
            title: "To Schedule calendar",
            variant: "secondary",
            linkto: "/schedules/calendar",
          },
          {
            icon: "fa-plus",
            title: "Add Schedule",
            variant: "success",
            linkto: `/schedules/add/${this.selected_date}`,
            permission: this.checkPermission("add schedule"),
          },
        ],
      };
    },
    selected_date_obj() {
      return moment(this.selected_date);
    },
    date_for_title() {
      return this.selected_date_obj.format("dddd, Do MMMM");
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    updateTables() {
      this.$refs["schedules-table"].refresh();
    },
  },
};
</script>
